import React,{ PureComponent}   from 'react';
import './PullOnLoading.scss';
import Contain from 'common/components/contain/Contain';
import PullOnLoadingTips from './PullOnLoadingTips';
import $ from 'jquery';
import utils from 'common/js/utils';

export default class PullOnLoading extends React.Component {

    componentDidMount() {
        var self = this,
            winHeight = $(window).height();
        $(window).on('scroll', utils.throttle(function() {
            let $doc = $(document),
                docHeight = $doc.height();

            if($doc.scrollTop() + winHeight >= docHeight - 200 ) {
                self.props.bIsMore && self.props.fLoad();
            }
        }, 500, 500));
    }

    componentWillUnmount() {
        $(window).off('scroll');
    }

    render() {
        return(
            <Contain id="J-contain" {...this.props}>
                {this.props.children}
                <PullOnLoadingTips/>
            </Contain>
        )
    }
}


// WEBPACK FOOTER //
// ./src/common/components/pull-on-loading/PullOnLoading.jsx